import {inject} from '@angular/core';
import {CanActivateFn, Router} from '@angular/router';
import {OidcSecurityService} from 'angular-auth-oidc-client';
import {map} from 'rxjs';

import {hasAnyRoleInSet, loadUserRoles} from './role-access';

/**
 * Protect routes in addition to hiding their navigation entries.
 * Show access denied when an authenticated account lacks the required role.
 * Keep missing routes separate so a valid landing page does not appear broken.
 */
export const roleGuard: CanActivateFn = route => {
  const oidcSecurityService = inject(OidcSecurityService);
  const router = inject(Router);
  const allowedRoles = route.data?.['roles'] as readonly string[] | undefined;

  if (!allowedRoles?.length) {
    return true;
  }

  return loadUserRoles(oidcSecurityService).pipe(
    map(roles => hasAnyRoleInSet(roles, allowedRoles)
      ? true
      : router.createUrlTree(['/error/403'])),
  );
};
